import { styled } from '@mui/material';

export const ModelRow = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0.5rem 1rem',
});

export const ModelName = styled('div')({
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
});

export const ModelButtons = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '0.1rem',
});
